//Consider adding validation package in the future. For now we just check for 11 numerical digits and that the number is formatted as either +1-XXX-XXX-XXXX, 1-XXX-XXX-XXXX, XXX-XXX-XXXX, or XXXXXXXXXXX.
const isValidPhoneNumber = (number: string): boolean => {
    let containsInvalidChars = number.match(/^(\+1-|1-)?\d{3}-\d{3}-\d{4}$|^\d{11}$/) === null;
    let formattedNumber = number.replace(/[^0-9]/g, '');
    return formattedNumber.length === 11 && !containsInvalidChars;
};

export default isValidPhoneNumber;